"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tdClassName = exports.Cell = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var keyboard_1 = require("../hooks/keyboard");
exports.Cell = (0, react_1.forwardRef)(function (_a, ref) {
    var onEnter = _a.onEnter, onChangeFocus = _a.onChangeFocus, _b = _a.focusable, focusable = _b === void 0 ? false : _b, sticky = _a.sticky, index = _a.index, testId = _a.testId, props = __rest(_a, ["onEnter", "onChangeFocus", "focusable", "sticky", "index", "testId"]);
    var _c = (0, keyboard_1.useCellKeyboardControls)({ onEnter: onEnter, onChangeFocus: onChangeFocus }), onKeyDown = _c.onKeyDown, onBlur = _c.onBlur;
    return (react_1.default.createElement(StyledTD, __assign({ className: exports.tdClassName, ref: ref, "data-cellindex": index, role: "button", onBlur: onBlur, onKeyDown: onKeyDown, focusable: focusable, sticky: sticky, "data-testid": testId }, props)));
});
exports.tdClassName = "newfront-spreadsheet--td";
var StyledTD = styled_components_1.default.div(function (_a) {
    var focusable = _a.focusable, sticky = _a.sticky;
    return "\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  padding: 12px 8px;\n  &:focus,&:focus-within {\n    box-shadow: ".concat(focusable ? "inset 0 0 0 2px ".concat(core_ui_1.colors.brand[300]) : 'unset', ";\n    outline: 0;\n  }\n  ").concat(sticky &&
        sticky === 'right' &&
        "\n    position: sticky;\n    right: 0;\n\n    &:before {\n      content: '';\n      position: absolute;\n      left: -10px;\n      top: 0;\n      width: 10px;\n      height: 100%;\n      background: linear-gradient(to right, rgba(255, 255, 255, 0.2) 0%, rgba(219, 219, 219, 0.6) 100%);\n    }\n  }", "\n");
});
